module.exports = __webpack_public_path__ + "static/media/picture-(282).4cad4da7.JPG";